import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { defineMessages, useIntl, FormattedMessage } from 'react-intl';
import { Menu, Button } from 'semantic-ui-react';
import { map } from 'lodash';
import cx from 'classnames';
import { BodyClass, getBaseUrl, hasApiExpander } from '@plone/volto/helpers';
import config from '@plone/volto/registry';
import { getNavigation } from '@plone/volto/actions';
import { CSSTransition } from 'react-transition-group';
import NavItems from '@plone/volto/components/theme/Navigation/NavItems';
import Logo from '@plone/volto/components/theme/Logo/Logo';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faXTwitter, faWhatsapp, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';
const socialIcons = {
  facebook: faFacebookF,
  twitter: faXTwitter,
  youtube: faYoutube,
  whatsapp: faWhatsapp,
  instagram: faInstagram
}

// I18N messages
const messages = defineMessages({
  xxss: {
    id: 'Our social networks',
    defaultMessage: 'Our social networks',
  },
});


const Navigation = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { pathname, type } = props;
  const [isMobileMenuOpen, setisMobileMenuOpen] = useState(false);
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const items = useSelector((state) => state.navigation.items, shallowEqual);
  const lang = useSelector((state) => state.intl.locale);

  useEffect(() => {
    const { settings } = config;
    if (!hasApiExpander('navigation', getBaseUrl(pathname))) {
      dispatch(getNavigation(getBaseUrl(pathname), settings.navDepth));
    }
  }, [pathname, token, dispatch]);

  const toggleMobileMenu = () => {
    setisMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    if (!isMobileMenuOpen) {
      return;
    }
    setisMobileMenuOpen(false);
  };

  // Get Social networks links
  const { socialActions = [] } = useSelector(
    (state) => ({
      socialActions: state.actions?.actions?.social_actions,
    }),
    shallowEqual,
  );

  // Is minisite?
  const navroot = useSelector((state) => state.navroot.data);

  return (
    <>
      {items.length > 0 &&
        <nav className="navigation mnPrincipal d-print-none" id="navigation" aria-label="Site">

          <div className="d-flex justify-content-end p-1 mt-0 d-xl-none">
            <Button className='navToggle' type="button" onClick={toggleMobileMenu} as="button" basic>
              <span className={(navroot?.custom_root && navroot?.custom_root?.['@type'] === 'Minisite') ? "" : "visually-hidden"}><FormattedMessage id="Menu" defaultMessage="Menu" /></span> {/* Show text in minisites */}
              <FontAwesomeIcon icon={faBars} />
            </Button>
          </div>

          <Menu
            stackable
            pointing
            secondary
            className="desktop-menu-nav list-unstyled d-none d-xl-flex"
            onClick={closeMobileMenu}
            as='ul'
          >
            <NavItems items={items} lang={lang} mobile={false} />
          </Menu>
          <CSSTransition
            in={isMobileMenuOpen}
            timeout={250}
            classNames=""
            unmountOnExit
          >
            <div key="mobile-menu-key" className="mobile-menu">
              <div className="logoBar d-flex align-items-center mb-4 pb-3">
                <Logo />
                <Button className='navToggle topBar__btn  ms-auto' type="button" onClick={toggleMobileMenu} as="button" basic>
                  <FontAwesomeIcon icon={faXmark} className='me-1' />
                  <span className="visually-hidden"><FormattedMessage id="Close menu" defaultMessage="Close menu" /></span>
                </Button>
              </div>
              <BodyClass className="has-mobile-menu-open" />
              <div className="mobile-menu-nav">
                <Menu stackable pointing secondary onClick={closeMobileMenu} as='ul' className='list-unstyled'>
                  <NavItems items={items} lang={lang} mobile={true} />
                </Menu>

                {/* SNS */}
                {socialActions?.length > 0 &&
                  <Button.Group className='XXSS d-lg-inline-flex ms-xl-3' basic aria-label={intl.formatMessage(messages.xxss)} >
                    {map(socialActions, (item) => (
                      <Button as="a" basic className="XXSS__link  topBar__btn" href={item.url} key={item.id}>
                        <FontAwesomeIcon icon={socialIcons[item.id]} className='XXSS__icon' />
                        <span className="visually-hidden">{item?.title}</span>
                      </Button>
                    ))}
                  </Button.Group>
                }
              </div>
            </div>
          </CSSTransition>
        </nav>
      }
    </>
  );
};

Navigation.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export default Navigation;
